<h2>
  Detalhes do avalista
  <span *ngIf="fichaCadastro.avalistas.length > 1">{{ numeroAvalista }}</span>
</h2>
<form #formDetalheAvalista="ngForm" id="formDetalheAvalista">
  <div class="row">
    <div class="form-group">
      <span class="icon user"></span>
      <div class="inputs">
        <label for="user-name">Nome</label>
        <input
          type="text"
          class="form-control"
          id="user-name"
          name="nomeAvalista"
          [(ngModel)]="fichaCadastro?.avalistas[index].nome"
          uppercase
          maxlength="60"
          required
          appShowErrorMessages
          requiredMessage="Nome do Avalista é obrigatório"
          placeholder="Nome do Avalista"
          uppercase
          appMinTwoWords
          [removeSpaceBeginEnd]="true"
          [charOnly]="true"
        />
      </div>
    </div>

    <div class="form-group">
      <span class="icon email"></span>
      <div class="inputs">
        <label for="user-email">Email</label>
        <input
          maxlength="100"
          type="text"
          class="form-control"
          maxlength="100"
          id="user-email"
          placeholder="email@exemplo.com.br"
          lowercase
          name="emailAvalista"
          [(ngModel)]="fichaCadastro.avalistas[index].email"
          [email]="true"
          appEmailValidator
          appShowErrorMessages
          requiredMessage="Email da Referencia é obrigatório"
          (focus)="clearErrorMessage('errorMessageEmail')"
          genericErrorMessage
          [ngModelOptions]="{ updateOn: 'blur' }"
          (blur)="onBlurEmailAvalista(fichaCadastro.avalistas[index].email)"
        />
        <div class="text-danger" *ngIf="isEmailInvalido">
          <ng-container *ngIf="errorMessageEmail">
            {{ errorMessageEmail }}
          </ng-container>
          <ng-container *ngIf="!errorMessageEmail">
            O E-mail informado não pode ser igual ao do Cliente ou de outro
            Avalista
          </ng-container>
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon married"></span>
      <div class="inputs">
        <label for="user-married">Estado Civil</label>
        <select
          *ngIf="!isLoadingEstadosCivis"
          class="form-control"
          id="user-married"
          name="estadoCivilAvalista"
          [(ngModel)]="civilState"
          appShowErrorMessages
          required
          requiredMessage="Estado Civil é obrigatório"
        >
          <option value="undefined" selected hidden>Selecione...</option>
          <option
            *ngFor="let estadoCivil of listaEstadosCivis"
            value="{{ estadoCivil.id }}"
          >
            {{ estadoCivil.descricao }}
          </option>
        </select>
        <span *ngIf="isLoadingEstadosCivis">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Carregando...
        </span>
      </div>
    </div>

    <div class="form-group pb0">
      <span class="icon id-number"></span>
      <div class="inputs">
        <label for="user-id">Identificação</label>
        <select
          class="form-control"
          id="user-id"
          name="tipoDocumentoAvalista"
          (change)="onChangeTipoDocumentoAvalista($event)"
          [(ngModel)]="identification"
          appShowErrorMessages
          required
        >
          <option value="undefined" selected hidden>
            Selecione o tipo de documento...
          </option>
          <option value="2">Carteira de Classe</option>
          <option value="4">Carteira de Habilitação</option>
          <option value="3">Carteira Profissional</option>
          <option value="1">Registro Geral - RG</option>
        </select>
      </div>
    </div>

    <!-- DADOS DOCUMENTOS -->
    <div class="form-group pb0">
      <span class="icon"></span>
      <div class="inputs">
        <label for="user-id">Número</label>
        <input
          type="text"
          maxlength="20"
          class="form-control"
          name="numeroDocumentoAvalista"
          [(ngModel)]="fichaCadastro.avalistas[index].rgIe"
          placeholder="Digite..."
          [justNumber]="true"
          appShowErrorMessages
          requiredMessage="Número de Documento do Avalista é obrigatório"
          required
          uppercase
        />
      </div>
    </div>

    <div class="form-group pb0">
      <span class="icon"></span>
      <div class="inputs">
        <label for="user-id">Órgão Expedidor</label>
        <input
          maxlength="20"
          type="text"
          class="form-control"
          name="orgaoDocumentoAvalista"
          [(ngModel)]="fichaCadastro.avalistas[index].rgIeEmissor"
          placeholder="Digite..."
          #orgaoDocumentoAvalistaInput="ngModel"
          appShowErrorMessages
          required
          [charOnly]="true"
          uppercase
        />
        <div
          class="text-danger"
          *ngIf="
            orgaoDocumentoAvalistaInput?.errors?.required &&
            orgaoDocumentoAvalistaInput?.touched
          "
        >
          Órgão Expedidor do Documento do Avalista é obrigatório
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon"></span>
      <div class="inputs">
        <label for="emiss-doc">Data de Emissão</label>
        <input
          type="text"
          appDataEmissaoValidator
          [dataNascimento]="fichaCadastro.avalistas[index].dataNascimento"
          class="form-control"
          id="emiss-doc"
          name="emissaoDocumentoAvalista"
          [(ngModel)]="fichaCadastro.avalistas[index].rgIeData"
          placeholder="Digite apenas números"
          mask-number
          [mask]="'00/00/0000'"
          minlength="1"
          [dateCheck]="emissaoDocumentoAvalista"
          [dateMin]="minDataEmissao"
          [dateMax]="maxDataEmissao"
          #emissaoDocumentoAvalistaInput="ngModel"
          appShowErrorMessages
          required
        />
        <div
          class="text-danger"
          *ngIf="emissaoDocumentoAvalistaInput?.errors?.dateCheck"
        >
          Data de emissão do Documento do Avalista inválida
        </div>
        <div
          class="text-danger"
          *ngIf="emissaoDocumentoAvalistaInput?.errors?.dateRange"
        >
          Data de emissão do Documento do Avalista deve ser entre
          {{ minDataEmissao }} e {{ maxDataEmissao }}
        </div>
        <div
          class="text-danger"
          *ngIf="
            emissaoDocumentoAvalistaInput?.errors?.required &&
            emissaoDocumentoAvalistaInput?.touched
          "
        >
          Data de Emissão do Documento do Avalista é obrigatória
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon mother"></span>
      <div class="inputs">
        <label for="nomeMaeAvalistaSel">Nome da Mãe</label>
        <input
          maxlength="60"
          type="text"
          class="form-control"
          id="user-mon-other-name"
          placeholder="Digite o nome completo"
          uppercase
          maxlength="60"
          name="nomeMaeAvalistaText"
          [charOnly]="true"
          [(ngModel)]="fichaCadastro.avalistas[index].nomeMae"
          appShowErrorMessages
          requiredMessage="Nome da Mãe do Avalista é obrigatório"
          required
        />
      </div>
    </div>

    <div class="form-group">
      <span class="icon father"></span>
      <div class="inputs">
        <label for="aval-father-name">Nome do Pai</label>
        <input
          maxlength="60"
          type="text"
          class="form-control"
          id="aval-father-name"
          placeholder="Digite o nome completo"
          uppercase
          [charOnly]="true"
          maxlength="60"
          name="nomePaiAvalista"
          [(ngModel)]="fichaCadastro.avalistas[index].nomePai"
          appShowErrorMessages
          [readonly]="isSemPaiNoRegistro"
          requiredMessage="Nome do Pai do Avalista é obrigatório"
          [required]="isNomePaiAvalista"
        />

        <div class="detalhe-avalista__switch marginT10 check-mod">
          <app-switch
            id="user-father-name"
            name="ufn"
            (change)="onClickNomePaiAvalista()"
            [(ngModel)]="isSemPaiNoRegistro"
          >
          </app-switch>
          <label>
            <span class="radio-label">Sem pai no registro</span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group pb0">
      <span class="icon citizenship"></span>
      <div class="inputs">
        <label for="user-citizenship">Nacionalidade</label>
        <select
          *ngIf="!isLoadingNacionalidadeAvalista"
          id="user-citizenship"
          class="form-control"
          name="nacionalidadeAvalista"
          appShowErrorMessages
          requiredMessage="Nacionalidade é obrigatório"
          required
          (change)="onChangeNacionalidadeAvalista($event)"
          [(ngModel)]="fichaCadastro.avalistas[index].idNacionalidade"
        >
          <option value="undefined" selected hidden>Selecione...</option>
          <option
            *ngFor="let nc of listaNacionalidadeAvalista"
            value="{{ nc.id }}"
          >
            {{ nc.descricao }}
          </option>
        </select>
        <span *ngIf="isLoadingNacionalidadeAvalista"
          ><i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Carregando...</span
        >
      </div>
    </div>

    <div class="form-group pb0">
      <span class="icon"></span>
      <div class="inputs">
        <label for="uf-nat-cli">Estado</label>
        <select
          id="uf-nat-cli"
          class="form-control"
          name="naturalUfAvalista"
          (change)="onChangeNaturalUfAvalista($event)"
          [disabled]="fichaCadastro.avalistas[index].idNacionalidade !== 1"
          [(ngModel)]="state"
          required
          appShowErrorMessages
        >
          <option value="undefined" selected hidden>Selecione...</option>
          <option value="AC">AC - Acre</option>
          <option value="AL">AL - Alagoas</option>
          <option value="AP">AP - Amapá</option>
          <option value="AM">AM - Amazonas</option>
          <option value="BA">BA - Bahia</option>
          <option value="CE">CE - Ceará</option>
          <option value="DF">DF - Distrito Federal</option>
          <option value="ES">ES - Espírito Santo</option>
          <option value="GO">GO - Goiás</option>
          <option value="MA">MA - Maranhão</option>
          <option value="MT">MT - Mato Grosso</option>
          <option value="MS">MS - Mato Grosso do Sul</option>
          <option value="MG">MG - Minas Gerais</option>
          <option value="PA">PA - Pará</option>
          <option value="PB">PB - Paraíba</option>
          <option value="PR">PR - Paraná</option>
          <option value="PE">PE - Pernambuco</option>
          <option value="PI">PI - Piauí</option>
          <option value="RJ">RJ - Rio de Janeiro</option>
          <option value="RN">RN - Rio Grande do Norte</option>
          <option value="RS">RS - Rio Grande do Sul</option>
          <option value="RO">RO - Rondônia</option>
          <option value="RR">RR - Roraima</option>
          <option value="SC">SC - Santa Catarina</option>
          <option value="SP">SP - São Paulo</option>
          <option value="SE">SE - Sergipe</option>
          <option value="TO">TO - Tocantins</option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <span class="icon"></span>
      <div class="inputs">
        <label for="user-city-cli">Cidade</label>
        <select
          *ngIf="!isLoadingNaturalCidadeAvalista"
          id="user-city-cli"
          class="form-control"
          [disabled]="!state"
          name="naturalCidadeAvalista"
          required
          appShowErrorMessages
          (change)="onChangeNaturalCidadeAvalista($event)"
          (blur)="onBlurNaturalCidadeAvalista($event)"
          [(ngModel)]="city"
        >
          <option value="undefined" selected hidden>Selecione...</option>
          <option
            *ngFor="let ncid of listaNaturalCidadeAvalista"
            value="{{ ncid.nomeCidade }}"
          >
            {{ ncid.nomeCidade }}
          </option>
        </select>
        <div
          class="text-danger"
          *ngIf="!isSelectedNaturalCidadeAvalistaAfterBlur"
        >
          Cidade de Origem do Avalista é obrigatório
        </div>
        <span *ngIf="isLoadingNaturalCidadeAvalista"
          ><i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Carregando...</span
        >
      </div>
    </div>

    <app-dados-profissionais
      #dadosProfissionaisAvalistaComponent
      name="dadosProfissionaisAvalista"
      [(ngModel)]="fichaCadastro.avalistas[index].dadoProfissional"
      ngDefaultControl
    >
    </app-dados-profissionais>

    <div class="form-group">
      <span class="icon patrimony"></span>
      <div class="inputs">
        <label for="user-patrimony">Valor total do Patrimônio</label>
        <input
          type="text"
          class="form-control"
          id="user-patrimony"
          placeholder="Digite apenas números"
          mask-money
          [prefix]="'R$'"
          [maxLength]="15"
          required
          name="valorPatrimonioAvalista"
          [(ngModel)]="fichaCadastro.avalistas[index].valorPatrimonio"
          appMoedaValidator
          [valorMinimo]="0.01"
          appOnlyDigitsLengthValidator
          #valorPatrimonioAvalistaInput="ngModel"
          appOnlyMoney
        />
        <small
          >EX: veículo, imóvel, investimentos...<br /><strong>Importante</strong
          >: essa é uma informação exigida pelo Banco Central.</small
        >
        <div
          class="text-danger"
          *ngIf="
            valorPatrimonioAvalistaInput?.errors?.required &&
            valorPatrimonioAvalistaInput?.touched
          "
        >
          Valor do Patrimônio do Avalista é obrigatório
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon public-person"></span>
      <div class="inputs">
        <label for="user-expose">Politicamente Exposto?</label>
        <small class="subtitle">
          Exerceu cargo político nos últimos 5 anos ou é parente de algum?
        </small>
        <div class="detalhe-avalista__switch marginT10 check-mod">
          <app-switch
            #avalistaPpe
            id="avalistaPpe"
            (change)="setAvalistaPpe($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Sim</span>
          </label>

          <app-switch
            class="detalhe-avalista__switch_button"
            #avalistaNaoPpe
            id="avalistaNaoPpe"
            (change)="setAvalistaPpe($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Não</span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon reference"></span>
      <div class="inputs">
        <label for="user-reference">Referência</label>
        <input
          maxlength="40"
          type="text"
          class="form-control"
          id="user-reference"
          placeholder="Digite o nome de uma referência do Avalista"
          uppercase
          maxlength="60"
          minlength="3"
          [charOnly]="true"
          name="nomeReferenciaAvalista"
          appShowErrorMessages
          requiredMessage="Nome da Referencia é obrigatório"
          [(ngModel)]="nomeReferencia"
          required
        />
      </div>
    </div>

    <div class="form-group">
      <span class="icon mobile"></span>
      <div class="inputs">
        <label for="user-reference-phone">Contato da Referência</label>
        <input
          type="text"
          class="form-control"
          id="user-reference-phone"
          placeholder="(00) 00000-0000"
          appTelefone
          [minLength]="11"
          name="foneReferenciaAvalista"
          [(ngModel)]="contatoReferencia"
          required
          appShowErrorMessages
          appOnlyDigitsLengthValidator
          requiredMessage="Celular da Referência é obrigatório"
          genericErrorMessage
          (focus)="clearErrorMessage('errorMessage')"
          [ngModelOptions]="{ updateOn: 'blur' }"
          (blur)="onBlurTelefoneReferenciaAvalista(contatoReferencia)"
          appCelularValidator
        />
        <div *ngIf="errorMessage" class="text-danger">
          {{ errorMessage }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon"></span>
      <div class="inputs">
        <label for="user-reference-relation">Relação com a Referência</label>
        <select
          id="user-reference-relation"
          class="form-control"
          name="relacReferenciaAvalista"
          (change)="onChangeRelacReferenciaAvalista($event)"
          [(ngModel)]="relacaoReferencia"
          appShowErrorMessages
          required
          requiredMessage="Relação com a Referencia é obrigatório"
        >
          <option value="undefined" selected hidden>Selecione</option>
          <option value="1">Amigo</option>
          <option value="2">Parente</option>
          <option value="3">Vizinho</option>
          <option value="4">Outros</option>
        </select>
      </div>
    </div>
  </div>
</form>

<div class="row">
  <div class="marginT30 form-group tab-buttons">
    <a
      (click)="onClickPrevious()"
      class="bt-back btn btn-border-orange pull-left"
      ><i class="fa fa-arrow-left mrBt"></i> Voltar</a
    >
    <a
      class="bt-go btn btn-full-orange pull-right"
      [ngClass]="{ disabled: !isNextAvailable(formDetalheAvalista) }"
      (click)="onClickNext()"
      >Continuar <i class="fa fa-arrow-right mlBt"></i
    ></a>
  </div>
</div>
